import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';

@Component({
    selector: 'scpi-amount',
    templateUrl: './scpi-amount.component.html',
    styleUrls: ['./scpi-amount.component.scss'],
    standalone: false
})
export class ScpiAmountComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    const scpiType =
      this.subscriptionFacade.getPledge()?.parameters?.scpiSelectionType;
    if (scpiType === 'PACK') {
      this.subscriptionFacade.setCommand([
        CommandEnum.GENERATE_SCPI_PRODUCTS_FROM_PACK,
        CommandEnum.COMPLETE_PRODUCTS_DATA,
        CommandEnum.GENERATE_ADDITIONAL_QUESTIONS,
      ]);
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
